<template>
  <section
    id="hero"
    class="l-hero"
  >
    <div class="o-container">
      <!-- eslint-disable vue/no-v-html -->
      <h1
        class="l-hero__title"
        v-html="content.title"
      />

      <p
        class="l-hero__description"
        v-html="content.description"
      />
      <!-- eslint-enable -->
      <a
        v-webview-open-universal-link="'none'"
        :href="content.actionLink"
        class="l-hero__action l-button o-button -xs-large -xs-primary"
      >
        {{ content.actionText }}
      </a>
    </div>
  </section>
</template>

<script>
  import webviewOpenUniversalLink from '@/tools/directives/webview-open-universal-link'

  import { CONTENTS } from './constants'

  export default {
    directives: {
      webviewOpenUniversalLink
    },
    props: {
      mode: {
        type: String,
        required: true
      }
    },
    computed: {
      content() {
        return CONTENTS[this.mode]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .l-hero {
    margin-top: 64px;
    padding: 0 20px;

    @include breakpoint(md) {
      margin-top: 104px;
    }

    &__title {
      font-weight: $font-weight-extra-bold;
      font-size: 32px;
      line-height: 36px;

      @include breakpoint(md) {
        font-size: 48px;
        line-height: 52px;
      }
    }

    &__description {
      line-height: 24px;
      margin: 40px 0;

      @include breakpoint(md) {
        margin: 32px auto 40px;
        color: $color-text-extra-dark;
        font-size: 20px;
      }
    }

    &__action {
      margin-top: 24px;
      width: 100%;
      text-transform: lowercase;
      font-size: 16px;
      font-weight: $font-weight-bold;

      @include breakpoint(md) {
        margin-top: 40px;
        width: auto;
      }
    }
  }

  .o-container {
    max-width: 1067px;
  }
</style>
